export function getNumericFieldValidationRules(
  fieldName: string,
  minValue: number | undefined,
  maxValue: number | undefined,
  isRequired: boolean
) {
  return {
    ...(isRequired ? { required: `${fieldName} is required` } : {}),
    ...(minValue != null ? { min: { value: minValue, message: `${fieldName} must be at least ${minValue}` } } : {}),
    ...(maxValue != null ? { max: { value: maxValue, message: `${fieldName} must be at most ${maxValue}` } } : {}),
  };
}

export function getNumericFieldRangeLabel(
  minValue: number | undefined,
  maxValue: number | undefined
): string | null {
  if (minValue == null && maxValue == null) return null;
  if (minValue != null && maxValue != null) return `Range: ${minValue} – ${maxValue}`;
  if (minValue != null) return `Min: ${minValue}`;
  return `Max: ${maxValue!}`;
}
